// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.logistic-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-weight: 700;
}

.logistic-modal-subheader {
  color: #535861;
}

.logistic-modal-left-container {
  border: 1px solid #e9eaec;
  border-radius: 10px;
  padding: 16px;
}

.logistic-modal-address {
  display: flex;
  gap: 8px;
  margin-bottom: 12px;
}

.location-indicator {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 3px;
}

.pickup-inner-dot {
  height: 10px;
  width: 10px;
  background-color: #0860e6;
  border-radius: 50%;
}

.pickup-outer-dot {
  padding: 2px;
  border: 3px solid #d9f2ff;
  border-radius: 50%;
  height: max-content;
  width: max-content;
}

.location-dash-line {
  flex: 1;
  border-left: 2px dashed #67b5dc;
}

.drop-dot {
  background-color: #2a71ff;
  border-radius: 50%;
  padding: 3px;
}

.location-inputs {
  width: 100%;
}

.logistic-pickup-input {
  width: 100%;
  padding: 8px;
  border-radius: 6px;
  border: 1px solid #d5d7db;
}

.logistic-modal-address-pickup {
  margin-bottom: 10px;
}

.logistic-card-container {
  font-weight: 700;
  font-size: 0.875rem;
  color: #000000;
}

.logistic-card-wrapper {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-top: 10px;
}

.logistic-vehicle-card {
  border: 1px solid #e9eaec;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 16px 8px;
  width: 100%;
  cursor: pointer;
}

.selected-vehicle {
  border: 1px solid #2a71ff;
  background-color: #edf8ff;
}

.logistic-schedule-container {
  font-weight: 700;
  font-size: 0.875rem;
  color: #000000;
  margin-top: 10px;
}

.logistic-schedule-slot-container {
  display: flex;
  align-items: center;
  gap: 8px;
}

.logistic-schedule-button-wrapper {
  display: flex;
  align-items: center;
  gap: 4px;
  font-weight: 600;
  color: #717681;
  border: 1px solid #e9eaec;
  border-radius: 6px;
  padding: 6px 8px;
  cursor: pointer;
}

.selected-schedule {
  border: 1px solid #2a71ff;
  background-color: #edf8ff;
  color: #0860e6;
}

.logistic-date-picker-container {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 10px;
}

.logistic-date-picker-wrapper {
  width: 100%;
  font-weight: 600;
  color: #535861;
}

.logistic-date-input {
  width: 100%;
  border: 1px solid #d5d7db;
  border-radius: 20px;
  padding: 6px 8px;
  color: #535861;
}

.logistic-action-button {
  margin-top: 10px;
}

.logistic-book-button-container {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.logistic-modal-footer-line {
  border: none;
  height: 1px;
  background-color: #e9eaec;
}

.logistic-modal-footer {
  border-top: 1px solid #e9eaec;
  padding-top: 4px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  width: 100%;
}

.logistic-modal-right-container {
  background-color: #f5f5f6;
  height: 100%;
  border-radius: 8px;
  padding: 16px;
}

.logistic-right-empty-container {
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.logistic-empty-header {
  color: #414652;
  font-size: 0.875rem;
  font-weight: 600;
}

.logistic-empty-subheading-container {
  max-width: 400px;
  text-align: center;
  font: 0.813rem;
  color: #717681;
  font-weight: 400;
}

.custom-time-picker {
  display: flex;
  width: 100%;
  border: 1px solid #d0d5dd;
  border-radius: 6px;
  overflow: hidden;
  background: white;
  height: 40px;
}

.time-column {
  flex: 1;
  border-right: 1px solid #d0d5dd;
}

.time-column:last-child {
  border-right: none;
}

.time-column select {
  width: 100%;
  height: 100%;
  border: none;
  outline: none;
  text-align: center;
  font-size: 14px;
  background: transparent;
  cursor: pointer;
}

.logistic-vehicle-wrapper {
  background-color: var(--surface-white);
  border: 1px solid #e9eaec;
  border-radius: 8px;
  padding: 8px 12px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
}

.logistic-provider-wrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.logistic-vehicle-porvider {
  font-weight: 700;
  font-size: 0.875rem;
  color: #252b36;
}

.logistic-vehicle-cost {
  font-weight: 700;
  font-size: 1rem;
  color: #252b36;
}

.logistic-vehicle-wrapper:hover {
  border-color: #0860e6;
  background-color: #f4f8ff;
}

.selected-delivery-partner {
  border: 2px solid #0860e6 !important;
  background-color: #e8f1ff;
}

.logistic-vehicle-eta {
  color: #535861;
  font-weight: 400;
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 0.875rem;
}

.logistic-provider-logo {
  background-color: var(--blue-b0);
  width: 100px;
  height: 60px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4px;
}

.logistic-vehicle-logo-name {
  font-size: 0.625rem;
  color: var(--surface-white);
  font-weight: 600;
}

.logistic-provider-outer-wrapper {
  width: 100%;
}

.logistic-modal-header-section {
  padding: 16px;
  border-bottom: 1px solid #e9eaec;
}

.logistic-modal-body {
  flex: 1;
  overflow-y: auto;
  display: flex;
}

.logistic-modal-body .MuiGrid-container {
  height: 100%;
}

.logistic-modal-left-container {
  border: 1px solid #e9eaec;
  border-radius: 10px;
  padding: 16px;
  display: flex;
  flex-direction: column;
  height: 100%;
}

.logistic-action-button {
  margin-top: auto;
}

.logistic-modal-right-container {
  background-color: #f5f5f6;
  border-radius: 8px;
  padding: 16px;
  height: 100%;
  overflow-y: auto;
}

.logistic-modal-content {
  width: 100%;
}

.logistic-input-wrapper {
  position: relative;
  display: flex;
  align-items: center;
}

.loaderInsideInput {
  position: absolute;
  right: 8px;
  top: 8px;
}

.logistic-rigt-container-header {
  font-weight: 700;
  font: 0.875rem;
  margin-bottom: 6px;
}

@media (max-width: 768px) {
  .logistic-modal-body {
    flex-direction: column;
  }

  .logistic-modal-footer {
    position: sticky;
    bottom: 0;
  }
}

/* ── Dark mode ── */
.dark .logistic-modal-left-container {
  border-color: #334155;
  background: #1e293b;
}

.dark .logistic-modal-subheader {
  color: #94a3b8;
}

.dark .logistic-modal-header-section {
  border-bottom-color: #334155;
}

.dark .logistic-card-container,
.dark .logistic-schedule-container {
  color: #e2e8f0;
}

.dark .logistic-vehicle-card {
  border-color: #334155;
  background: #1e293b;
}

.dark .logistic-vehicle-card:hover {
  border-color: #3b82f6;
}

.dark .selected-vehicle {
  border-color: #3b82f6;
  background-color: #172554;
}

.dark .logistic-schedule-button-wrapper {
  border-color: #334155;
  color: #94a3b8;
  background: #1e293b;
}

.dark .selected-schedule {
  border-color: #3b82f6;
  background-color: #172554;
  color: #60a5fa;
}

.dark .logistic-pickup-input,
.dark .logistic-date-input {
  background: #1e293b;
  border-color: #334155;
  color: #e2e8f0;
}

.dark .logistic-modal-right-container {
  background-color: #0f172a;
}

.dark .logistic-vehicle-wrapper {
  background-color: #1e293b;
  border-color: #334155;
}

.dark .logistic-vehicle-wrapper:hover {
  background-color: #172554;
  border-color: #3b82f6;
}

.dark .selected-delivery-partner {
  background-color: #172554;
  border-color: #3b82f6 !important;
}

.dark .logistic-vehicle-porvider,
.dark .logistic-vehicle-cost {
  color: #f1f5f9;
}

.dark .logistic-vehicle-eta {
  color: #94a3b8;
}

.dark .logistic-modal-footer-line {
  background-color: #334155;
}

.dark .logistic-modal-footer {
  border-top-color: #334155;
}

.dark .custom-time-picker {
  background: #1e293b;
  border-color: #334155;
}

.dark .time-column {
  border-right-color: #334155;
}

.dark .time-column select {
  background: #1e293b;
  color: #e2e8f0;
}

.dark .logistic-rigt-container-header {
  color: #e2e8f0;
}

.dark .logistic-empty-header {
  color: #cbd5e1;
}

.dark .logistic-empty-subheading-container {
  color: #94a3b8;
}
`, "",{"version":3,"sources":["webpack://./client/src/layouts/ecommerce/delivery/components/LogisticsModal.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,OAAO;EACP,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,6BAA6B;EAC7B,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,OAAO;EACP,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,sCAAsC;EACtC,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,gCAAgC;AAClC;;AAEA;EACE,OAAO;EACP,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,gBAAgB;IAChB,SAAS;EACX;AACF;;AAEA,oBAAoB;AACpB;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;;EAEE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB","sourcesContent":[".logistic-modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  font-weight: 700;\n}\n\n.logistic-modal-subheader {\n  color: #535861;\n}\n\n.logistic-modal-left-container {\n  border: 1px solid #e9eaec;\n  border-radius: 10px;\n  padding: 16px;\n}\n\n.logistic-modal-address {\n  display: flex;\n  gap: 8px;\n  margin-bottom: 12px;\n}\n\n.location-indicator {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding-top: 3px;\n}\n\n.pickup-inner-dot {\n  height: 10px;\n  width: 10px;\n  background-color: #0860e6;\n  border-radius: 50%;\n}\n\n.pickup-outer-dot {\n  padding: 2px;\n  border: 3px solid #d9f2ff;\n  border-radius: 50%;\n  height: max-content;\n  width: max-content;\n}\n\n.location-dash-line {\n  flex: 1;\n  border-left: 2px dashed #67b5dc;\n}\n\n.drop-dot {\n  background-color: #2a71ff;\n  border-radius: 50%;\n  padding: 3px;\n}\n\n.location-inputs {\n  width: 100%;\n}\n\n.logistic-pickup-input {\n  width: 100%;\n  padding: 8px;\n  border-radius: 6px;\n  border: 1px solid #d5d7db;\n}\n\n.logistic-modal-address-pickup {\n  margin-bottom: 10px;\n}\n\n.logistic-card-container {\n  font-weight: 700;\n  font-size: 0.875rem;\n  color: #000000;\n}\n\n.logistic-card-wrapper {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-top: 10px;\n}\n\n.logistic-vehicle-card {\n  border: 1px solid #e9eaec;\n  border-radius: 8px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 16px 8px;\n  width: 100%;\n  cursor: pointer;\n}\n\n.selected-vehicle {\n  border: 1px solid #2a71ff;\n  background-color: #edf8ff;\n}\n\n.logistic-schedule-container {\n  font-weight: 700;\n  font-size: 0.875rem;\n  color: #000000;\n  margin-top: 10px;\n}\n\n.logistic-schedule-slot-container {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.logistic-schedule-button-wrapper {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  font-weight: 600;\n  color: #717681;\n  border: 1px solid #e9eaec;\n  border-radius: 6px;\n  padding: 6px 8px;\n  cursor: pointer;\n}\n\n.selected-schedule {\n  border: 1px solid #2a71ff;\n  background-color: #edf8ff;\n  color: #0860e6;\n}\n\n.logistic-date-picker-container {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin-top: 10px;\n}\n\n.logistic-date-picker-wrapper {\n  width: 100%;\n  font-weight: 600;\n  color: #535861;\n}\n\n.logistic-date-input {\n  width: 100%;\n  border: 1px solid #d5d7db;\n  border-radius: 20px;\n  padding: 6px 8px;\n  color: #535861;\n}\n\n.logistic-action-button {\n  margin-top: 10px;\n}\n\n.logistic-book-button-container {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n}\n\n.logistic-modal-footer-line {\n  border: none;\n  height: 1px;\n  background-color: #e9eaec;\n}\n\n.logistic-modal-footer {\n  border-top: 1px solid #e9eaec;\n  padding-top: 4px;\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  width: 100%;\n}\n\n.logistic-modal-right-container {\n  background-color: #f5f5f6;\n  height: 100%;\n  border-radius: 8px;\n  padding: 16px;\n}\n\n.logistic-right-empty-container {\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n}\n\n.logistic-empty-header {\n  color: #414652;\n  font-size: 0.875rem;\n  font-weight: 600;\n}\n\n.logistic-empty-subheading-container {\n  max-width: 400px;\n  text-align: center;\n  font: 0.813rem;\n  color: #717681;\n  font-weight: 400;\n}\n\n.custom-time-picker {\n  display: flex;\n  width: 100%;\n  border: 1px solid #d0d5dd;\n  border-radius: 6px;\n  overflow: hidden;\n  background: white;\n  height: 40px;\n}\n\n.time-column {\n  flex: 1;\n  border-right: 1px solid #d0d5dd;\n}\n\n.time-column:last-child {\n  border-right: none;\n}\n\n.time-column select {\n  width: 100%;\n  height: 100%;\n  border: none;\n  outline: none;\n  text-align: center;\n  font-size: 14px;\n  background: transparent;\n  cursor: pointer;\n}\n\n.logistic-vehicle-wrapper {\n  background-color: var(--surface-white);\n  border: 1px solid #e9eaec;\n  border-radius: 8px;\n  padding: 8px 12px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.logistic-provider-wrapper {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.logistic-vehicle-porvider {\n  font-weight: 700;\n  font-size: 0.875rem;\n  color: #252b36;\n}\n\n.logistic-vehicle-cost {\n  font-weight: 700;\n  font-size: 1rem;\n  color: #252b36;\n}\n\n.logistic-vehicle-wrapper:hover {\n  border-color: #0860e6;\n  background-color: #f4f8ff;\n}\n\n.selected-delivery-partner {\n  border: 2px solid #0860e6 !important;\n  background-color: #e8f1ff;\n}\n\n.logistic-vehicle-eta {\n  color: #535861;\n  font-weight: 400;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  font-size: 0.875rem;\n}\n\n.logistic-provider-logo {\n  background-color: var(--blue-b0);\n  width: 100px;\n  height: 60px;\n  border-radius: 8px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 4px;\n}\n\n.logistic-vehicle-logo-name {\n  font-size: 0.625rem;\n  color: var(--surface-white);\n  font-weight: 600;\n}\n\n.logistic-provider-outer-wrapper {\n  width: 100%;\n}\n\n.logistic-modal-header-section {\n  padding: 16px;\n  border-bottom: 1px solid #e9eaec;\n}\n\n.logistic-modal-body {\n  flex: 1;\n  overflow-y: auto;\n  display: flex;\n}\n\n.logistic-modal-body .MuiGrid-container {\n  height: 100%;\n}\n\n.logistic-modal-left-container {\n  border: 1px solid #e9eaec;\n  border-radius: 10px;\n  padding: 16px;\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n}\n\n.logistic-action-button {\n  margin-top: auto;\n}\n\n.logistic-modal-right-container {\n  background-color: #f5f5f6;\n  border-radius: 8px;\n  padding: 16px;\n  height: 100%;\n  overflow-y: auto;\n}\n\n.logistic-modal-content {\n  width: 100%;\n}\n\n.logistic-input-wrapper {\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n\n.loaderInsideInput {\n  position: absolute;\n  right: 8px;\n  top: 8px;\n}\n\n.logistic-rigt-container-header {\n  font-weight: 700;\n  font: 0.875rem;\n  margin-bottom: 6px;\n}\n\n@media (max-width: 768px) {\n  .logistic-modal-body {\n    flex-direction: column;\n  }\n\n  .logistic-modal-footer {\n    position: sticky;\n    bottom: 0;\n  }\n}\n\n/* ── Dark mode ── */\n.dark .logistic-modal-left-container {\n  border-color: #334155;\n  background: #1e293b;\n}\n\n.dark .logistic-modal-subheader {\n  color: #94a3b8;\n}\n\n.dark .logistic-modal-header-section {\n  border-bottom-color: #334155;\n}\n\n.dark .logistic-card-container,\n.dark .logistic-schedule-container {\n  color: #e2e8f0;\n}\n\n.dark .logistic-vehicle-card {\n  border-color: #334155;\n  background: #1e293b;\n}\n\n.dark .logistic-vehicle-card:hover {\n  border-color: #3b82f6;\n}\n\n.dark .selected-vehicle {\n  border-color: #3b82f6;\n  background-color: #172554;\n}\n\n.dark .logistic-schedule-button-wrapper {\n  border-color: #334155;\n  color: #94a3b8;\n  background: #1e293b;\n}\n\n.dark .selected-schedule {\n  border-color: #3b82f6;\n  background-color: #172554;\n  color: #60a5fa;\n}\n\n.dark .logistic-pickup-input,\n.dark .logistic-date-input {\n  background: #1e293b;\n  border-color: #334155;\n  color: #e2e8f0;\n}\n\n.dark .logistic-modal-right-container {\n  background-color: #0f172a;\n}\n\n.dark .logistic-vehicle-wrapper {\n  background-color: #1e293b;\n  border-color: #334155;\n}\n\n.dark .logistic-vehicle-wrapper:hover {\n  background-color: #172554;\n  border-color: #3b82f6;\n}\n\n.dark .selected-delivery-partner {\n  background-color: #172554;\n  border-color: #3b82f6 !important;\n}\n\n.dark .logistic-vehicle-porvider,\n.dark .logistic-vehicle-cost {\n  color: #f1f5f9;\n}\n\n.dark .logistic-vehicle-eta {\n  color: #94a3b8;\n}\n\n.dark .logistic-modal-footer-line {\n  background-color: #334155;\n}\n\n.dark .logistic-modal-footer {\n  border-top-color: #334155;\n}\n\n.dark .custom-time-picker {\n  background: #1e293b;\n  border-color: #334155;\n}\n\n.dark .time-column {\n  border-right-color: #334155;\n}\n\n.dark .time-column select {\n  background: #1e293b;\n  color: #e2e8f0;\n}\n\n.dark .logistic-rigt-container-header {\n  color: #e2e8f0;\n}\n\n.dark .logistic-empty-header {\n  color: #cbd5e1;\n}\n\n.dark .logistic-empty-subheading-container {\n  color: #94a3b8;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
